import { render, staticRenderFns } from "./TestimonialMobileView.vue?vue&type=template&id=036cf5cf&scoped=true&"
import script from "./TestimonialMobileView.vue?vue&type=script&lang=js&"
export * from "./TestimonialMobileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036cf5cf",
  null
  
)

export default component.exports